import { defineStore } from "pinia";

export default defineStore("user", {
	state: () => {
		return {
			wxloginState: false,
			avatarUrl: "111",
			nickName: "sxx",
			openId: "123",
		};
	},
	getters: {},
	actions: {},
	// 开始数据持久化
	persist: {
		enabled: false,
	},
});
